import bg404 from '../assets/images/allicons/bg404.svg'
import calendar from '../assets/images/allicons/calendar.svg'
import deleteicon from '../assets/images/allicons/deleteicon.svg'
import editicon from '../assets/images/allicons/editicon.svg'
import list from '../assets/images/allicons/list.svg'
import listblue from '../assets/images/allicons/listblue.svg'
import magnifier from '../assets/images/allicons/magnifier.svg'
import referral from '../assets/images/allicons/referral.svg'
import shield from '../assets/images/allicons/shield.svg'
import become_creator from '../assets/images/icons/become_creator.svg'
import button_block from '../assets/images/icons/button_block.svg'
import button_filter_black from '../assets/images/icons/button_filter-black.svg'
import button_info from '../assets/images/icons/button_info.svg'
import button_list_black from '../assets/images/icons/button_list-black.svg'
import button_list_blue from '../assets/images/icons/button_list-blue.svg'
import button_list from '../assets/images/icons/button_list.svg'
import button_repeat from '../assets/images/icons/button_repeat.svg'
import button_send from '../assets/images/icons/button_send.svg'
import button_settings from '../assets/images/icons/button_settings.svg'
import button_sort_black from '../assets/images/icons/button_sort-black.svg'
import button_sort from '../assets/images/icons/button_sort.svg'
import categories_media from '../assets/images/icons/categories_media.svg'
import chat_actions from '../assets/images/icons/chat_actions.svg'
import chat_bubble_blue from '../assets/images/icons/chat_bubble-blue.svg'
import chat_bubble from '../assets/images/icons/chat_bubble.svg'
import chat_delete from '../assets/images/icons/chat_delete.svg'
import chat_gif from '../assets/images/icons/chat_gif.svg'
import chat_info from '../assets/images/icons/chat_info.svg'
import chat_options from '../assets/images/icons/chat_options.svg'
import chat_plus from '../assets/images/icons/chat_plus.svg'
import chat_react from '../assets/images/icons/chat_react.svg'
import chat_reply from '../assets/images/icons/chat_reply.svg'
import chat_reply_outline from '../assets/images/icons/chat_reply_outline.svg'
import chat_video from '../assets/images/icons/chat_video.svg'
import checkmark_blue from '../assets/images/icons/checkmark-blue.svg'
import chevron_right from '../assets/images/icons/chevron-right.svg'
import chevron_down from '../assets/images/icons/chevron_down.svg'
import chevron_down_blue from '../assets/images/icons/chevron_down_blue.svg'
import close from '../assets/images/icons/close.svg'
import coin from '../assets/images/icons/coin.svg'
import comment_connect from '../assets/images/icons/comment_connect.svg'
import comment_ellipsis from '../assets/images/icons/comment_ellipsis.svg'
import comment_reply from '../assets/images/icons/comment_reply.svg'
import credit_cards from '../assets/images/icons/credit_cards.svg'
import discovery_black from '../assets/images/icons/discovery-black.svg'
import document from '../assets/images/icons/document.svg'
import dollar_with_arrows from '../assets/images/icons/dollar_with_arrows.svg'
import emoji_grin from '../assets/images/icons/emoji_grin.svg'
import emoji_heart from '../assets/images/icons/emoji_heart.svg'
import emoji_kiss from '../assets/images/icons/emoji_kiss.svg'
import emoji_like from '../assets/images/icons/emoji_like.svg'
import emoji_sad from '../assets/images/icons/emoji_sad.svg'
import emoji_tear from '../assets/images/icons/emoji_tear.svg'
import filter_white from '../assets/images/icons/filter_white.svg'
import footer_addpost from '../assets/images/icons/footer_addpost.svg'
import footer_chat_active from '../assets/images/icons/footer_chat-active.svg'
import footer_chat from '../assets/images/icons/footer_chat.svg'
import footer_closepost from '../assets/images/icons/footer_closepost.svg'
import footer_favorites from '../assets/images/icons/footer_favorites.svg'
import footer_favorites_active from '../assets/images/icons/footer_favorites_active.svg'
import footer_home_active from '../assets/images/icons/footer_home-active.svg'
import footer_home from '../assets/images/icons/footer_home.svg'
import footer_media from '../assets/images/icons/footer_media.svg'
import footer_media_active from '../assets/images/icons/footer_media_active.svg'
import footer_newmessage from '../assets/images/icons/footer_newmessage.svg'
import footer_newpost from '../assets/images/icons/footer_newpost.svg'
import footer_newstory from '../assets/images/icons/footer_newstory.svg'
import footer_notifications_active from '../assets/images/icons/footer_notifications-active.svg'
import footer_notifications from '../assets/images/icons/footer_notifications.svg'
import footer_search from '../assets/images/icons/footer_search.svg'
import footer_search_active from '../assets/images/icons/footer_search_active.svg'
import footer_user_active from '../assets/images/icons/footer_user-active.svg'
import footer_user from '../assets/images/icons/footer_user.svg'
import geoblock_success from '../assets/images/icons/geoblock-success.svg'
import globe_black from '../assets/images/icons/globe-black.svg'
import info from '../assets/images/icons/info.svg'
import info_circle from '../assets/images/icons/info_circle.svg'
import info_file from '../assets/images/icons/info_file.svg'
import info_mute from '../assets/images/icons/info_mute.svg'
import info_trash from '../assets/images/icons/info_trash.svg'
import info_user from '../assets/images/icons/info_user.svg'
import instagram_active from '../assets/images/icons/instagram_active.svg'
import menu_live from '../assets/images/icons/menu_live.png'
import menu_media from '../assets/images/icons/menu_media.svg'
import menu_subscriptions from '../assets/images/icons/menu_subscriptions.svg'
// import menu_vault from "../assets/images/icons/menu_vault.svg";
import menu_vault from '../assets/images/icons/menu_vault.png'
import payment_sub_white from '../assets/images/icons/payment_sub-white.svg'
import payment_sub from '../assets/images/icons/payment_sub.svg'
import phone_black from '../assets/images/icons/phone-black.svg'
import post_add from '../assets/images/icons/post_add.svg'
import post_copy from '../assets/images/icons/post_copy.svg'
import post_delete from '../assets/images/icons/post_delete.svg'
import post_edit from '../assets/images/icons/post_edit.svg'
import post_graph from '../assets/images/icons/post_graph.svg'
import post_image from '../assets/images/icons/post_image.svg'
import post_like from '../assets/images/icons/post_like.svg'
import post_like_red from '../assets/images/icons/post_like_red.svg'
import post_lock from '../assets/images/icons/post_lock.svg'
import post_lock_outline from '../assets/images/icons/post_lock_outline.svg'
import post_lock_outline_dark from '../assets/images/icons/post_lock_outline_dark.svg'
import post_options from '../assets/images/icons/post_options.svg'
import post_pin from '../assets/images/icons/post_pin.svg'
import post_play from '../assets/images/icons/post_play.svg'
import post_report from '../assets/images/icons/post_report.svg'
import post_stats from '../assets/images/icons/post_stats.svg'
import post_tip from '../assets/images/icons/post_tip.svg'
import post_video from '../assets/images/icons/post_video.svg'
import preview_chat from '../assets/images/icons/preview_chat.svg'
import preview_chevrondown from '../assets/images/icons/preview_chevrondown.svg'
import preview_close from '../assets/images/icons/preview_close.svg'
import preview_heart from '../assets/images/icons/preview_heart.svg'
import profile_checkcircle from '../assets/images/icons/profile_check-circle.svg'
import profile_friend from '../assets/images/icons/profile_friend.svg'
import profile_notification from '../assets/images/icons/profile_notification.svg'
import profile_pending from '../assets/images/icons/profile_pending.svg'
import settings_discovery from '../assets/images/icons/settings_discovery.svg'
import settings_live from '../assets/images/icons/settings_live.svg'
import settings_livestream from '../assets/images/icons/settings_livestream.svg'
import settings_mobile_big from '../assets/images/icons/settings_mobile-big.svg'
import settings_mobile from '../assets/images/icons/settings_mobile.svg'
import settings_notifications_inapp from '../assets/images/icons/settings_notifications_inapp.png'
import settings_phone from '../assets/images/icons/settings_phone.png'
import settings_story from '../assets/images/icons/settings_story.svg'
import settings_vallet from '../assets/images/icons/settings_vallet.svg'
import shield_done from '../assets/images/icons/shield_done.svg'
import smile from '../assets/images/icons/smile.svg'
import social_trade from '../assets/images/icons/social_trade.svg'
import square_minus from '../assets/images/icons/square_minus.svg'
import square_plus from '../assets/images/icons/square_plus.svg'
import sub_chat from '../assets/images/icons/sub_chat.svg'
import sub_close from '../assets/images/icons/sub_close.svg'
import sub_selfie from '../assets/images/icons/sub_selfie.svg'
import sub_star from '../assets/images/icons/sub_star.svg'
import tag_user from '../assets/images/icons/tag_user.svg'
import three_arrows_right from '../assets/images/icons/three_arrows_right.svg'
import trash_blue from '../assets/images/icons/trash-blue.svg'
import twitter_active from '../assets/images/icons/twitter_active.svg'
import twitter_inactive from '../assets/images/icons/twitter_inactive.svg'
import user_placeholder2 from '../assets/images/icons/user_placeholder-2.png'
import user_placeholder from '../assets/images/icons/user_placeholder.svg'
import video_fullscreen from '../assets/images/icons/video_fullscreen.svg'
import video_pause from '../assets/images/icons/video_pause.svg'
import video_play from '../assets/images/icons/video_play.svg'

export const AllIcons = {
    button_filter_black,
    button_block,
    button_info,
    button_list,
    button_list_black,
    button_list_blue,
    button_repeat,
    button_send,
    button_settings,
    button_sort,
    button_sort_black,
    become_creator,
    bg404,

    chat_actions,
    chat_bubble,
    chat_bubble_blue,
    chat_delete,
    chat_gif,
    chat_info,
    chat_options,
    chat_plus,
    chat_react,
    chat_reply,
    chat_reply_outline,
    chat_video,
    credit_cards,

    checkmark_blue,
    chevron_down,
    chevron_down_blue,
    chevron_right,
    close,
    coin,
    calendar,

    comment_connect,
    comment_ellipsis,
    comment_reply,

    discovery_black,
    document,
    dollar_with_arrows,

    emoji_grin,
    emoji_heart,
    emoji_kiss,
    emoji_like,
    emoji_sad,
    emoji_tear,

    footer_addpost,
    footer_closepost,
    footer_chat,
    footer_chat_active,
    footer_favorites,
    footer_favorites_active,
    footer_home,
    footer_home_active,
    footer_notifications,
    footer_notifications_active,
    footer_user,
    footer_user_active,
    footer_newmessage,
    footer_newpost,
    footer_newstory,
    footer_media,
    footer_search,
    footer_media_active,
    footer_search_active,

    globe_black,

    info,
    info_circle,

    info_file,
    info_mute,
    info_trash,
    info_user,

    twitter_active,
    twitter_inactive,
    instagram_active,

    menu_live,
    menu_media,
    menu_subscriptions,
    menu_vault,
    magnifier,

    phone_black,

    payment_sub,
    payment_sub_white,

    post_add,
    post_copy,
    post_delete,
    post_edit,
    post_graph,
    post_image,
    post_like,
    post_like_red,
    post_lock,
    post_lock_outline,
    post_lock_outline_dark,
    post_options,
    post_pin,
    post_play,
    post_report,
    post_stats,
    post_tip,
    post_video,

    preview_chat,
    preview_chevrondown,
    preview_close,
    preview_heart,

    profile_checkcircle,
    profile_friend,
    profile_notification,
    profile_pending,

    referral,

    settings_discovery,
    settings_live,
    settings_livestream,
    settings_mobile,
    settings_mobile_big,
    settings_notifications_inapp,
    settings_phone,
    settings_vallet,
    settings_story,

    shield_done,
    shield,
    smile,
    social_trade,

    sub_chat,
    sub_close,
    sub_selfie,
    sub_star,

    square_minus,
    square_plus,
tag_user,
    three_arrows_right,
    trash_blue,

    user_placeholder,
    user_placeholder2,

    video_fullscreen,
    video_pause,
    video_play,

    filter_white,

    categories_media,
    geoblock_success,
    list,
    listblue,
    editicon,
    deleteicon
}
